import { PAGE_HOME_INCLUSIONE, PAGE_HOME_URL, PAGE_INCLUSIONE_APPRENDIMENTO_ITALIANO, PAGE_INCLUSIONE_MILANO_L2 } from 'types/url';

export const breadcrumbPath = [
  {
    slash: 'Home',
    url: PAGE_HOME_URL,
  },
  {
    slash: 'WeMi inclusione',
    url: PAGE_HOME_INCLUSIONE,
  },
  {
    slash: 'Apprendimento della lingua italiana',
    url: PAGE_INCLUSIONE_APPRENDIMENTO_ITALIANO,
  },
  {
    slash: 'Milano L2',
    url: PAGE_INCLUSIONE_MILANO_L2,
  },
];
